import { render, staticRenderFns } from "./AddAdvert.vue?vue&type=template&id=3ca8205c"
import script from "./AddAdvert.vue?vue&type=script&lang=js"
export * from "./AddAdvert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports